const CACHE_KEY = 'gv-spot-latest';
const CACHE_TTL = 10 * 60 * 1000;
const GRAMS_PER_OZ = 31.1034768;
const SYMBOLS = { gold: 'XAU', silver: 'XAG', platinum: 'XPT', palladium: 'XPD' };
const pending = new Map();

function loadLatest(apiKey) {
  if (pending.has(apiKey)) return pending.get(apiKey);
  const request = (async () => {
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.time < CACHE_TTL && cached.rates) return cached.rates;
    } catch {}
    const url = `https://api.metalpriceapi.com/v1/latest?api_key=${encodeURIComponent(apiKey)}&base=EUR&currencies=XAU,XAG,XPT,XPD`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (!data.success || !data.rates) return null;
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), rates: data.rates }));
      } catch {}
      return data.rates;
    } catch {
      return null;
    }
  })();
  pending.set(apiKey, request);
  return request;
}

/** Parses the "Hmotnosť" metafield ("31,1g", "1000g", "1 kg", "1 Unca", "1/2 Unce") into grams. */
function parseGrams(raw) {
  const text = String(raw || '').toLowerCase().replace(/,/g, '.').trim();
  if (!text) return NaN;
  const fraction = text.match(/(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)/);
  const number = fraction ? Number(fraction[1]) / Number(fraction[2]) : Number((text.match(/\d+(?:\.\d+)?/) || [])[0]);
  if (!Number.isFinite(number) || number <= 0) return NaN;
  if (/unc|oz|ounce/.test(text)) return number * GRAMS_PER_OZ;
  if (/kg/.test(text)) return number * 1000;
  return number;
}

class SpotPremium extends HTMLElement {
  connectedCallback() {
    this.#render();
  }

  async #render() {
    const apiKey = this.dataset.apiKey;
    const symbol = SYMBOLS[this.dataset.metal];
    const grams = parseGrams(this.dataset.weight);
    const price = Number(this.dataset.price) / 100;
    if (!apiKey || !symbol || !Number.isFinite(grams) || !(price > 0)) return;
    const rates = await loadLatest(apiKey);
    if (!this.isConnected || !rates) return;
    // API returns either EURXAU (EUR per ounce) or XAU (ounces per EUR); support both.
    const direct = Number(rates[`EUR${symbol}`]);
    const inverse = Number(rates[symbol]);
    const perOz = Number.isFinite(direct) && direct > 0 ? direct : inverse > 0 ? 1 / inverse : NaN;
    if (!Number.isFinite(perOz)) return;
    const spotValue = (perOz / GRAMS_PER_OZ) * grams;
    const premium = (price / spotValue - 1) * 100;
    if (!Number.isFinite(premium)) return;
    const formatted = new Intl.NumberFormat('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay: 'always' }).format(premium);
    const value = this.querySelector('[data-spot-value]');
    if (value) value.textContent = `${formatted} %`;
    this.hidden = false;
  }
}

if (!customElements.get('s-spot-premium')) customElements.define('s-spot-premium', SpotPremium);
